import memoizeOne from "memoize-one";
import { checkIfTimeRangeOverlaps } from "./DateTimeUtils";
import { isFinite, memoize } from "lodash";
import moment from "moment";
import { SectorType } from "../constans/sectorTypes";
import {
    getTimeOnBirthRoom,
    getTimeOnMatingRoom,
    getTimeOnPigletHouse,
    getTimeOnPorkHouse,
    getTimeOnSowsRoom
} from "./SettingsUtils";
import { getChamberFromPlacements } from "./device-rows/DeviceRowUtils";

function _checkIfSettlementOverlaps({ PlcmntID, DtaStartTime, DtaEndTime, FTIID } = {}, settlementList = []) {
    console.log("_checkIfSettlementOverlaps", arguments);
    const overlapsWith = [];
    settlementList.forEach((settlement) => {
        if (FTIID !== settlement.FTIID && PlcmntID === settlement.PlcmntID) {
            if (checkIfTimeRangeOverlaps(DtaStartTime, DtaEndTime || Number.MAX_SAFE_INTEGER, settlement.DtaStartTime, settlement.DtaEndTime || Number.MAX_SAFE_INTEGER)) {
                overlapsWith.push(settlement);
            }
        }
    });
    return overlapsWith;
}

export const checkIfSettlementOverlaps = memoizeOne(_checkIfSettlementOverlaps);

export const dataFormat = date => isFinite(date) ? moment.utc(date).format("L") : "...";

export const checkIfIsInSettlement = settlement => {
    if (!settlement) return false;
    const now = moment.utc().startOf("day");
    const start = moment.utc(settlement.DtaStartTime).startOf("day");
    const end = moment.utc(settlement.DtaEndTime || +moment.utc().endOf("day").add(10, "years")).endOf("day");
    const result = now.isBetween(start, end, undefined, "[]");
    console.log(settlement, "checkIfIsInSettlement", result, +now, +start, +end);
    return result;
};


export const getSettlementParams = (settlementList, selected) => {
    try {
        const tmp = {};
        if (selected.length === 1) {
            const chamber = getChamberFromPlacements(selected[0].placements);
            if (chamber) {
                tmp.CID = chamber.id;
                tmp.settlement = settlementList.filter(o => o.PlcmntID === tmp.CID).slice(0).sort((o1, o2) => o1.DtaStartTime - o2.DtaStartTime).filter(o => checkIfIsInSettlement(o))[0] || null;
                return tmp;
            }
        }
    } catch (err) {
        console.warn(err);
    }
    return {};
};

function _getDates(currentUTC) {
    return {
        monthAgo: { start: moment.utc().startOf("day").subtract(29, 'days'), end: moment.utc().startOf("day") },
        weekAgo: { start: moment.utc().startOf("day").subtract(6, 'days'), end: moment.utc().startOf("day") },
        threeMonthsAgo: { start: moment.utc().startOf("day").subtract(89, 'days'), end: moment.utc().startOf("day") }
    };
}

const getDates = memoize(_getDates);

export function getDurationOptions(t, settlements, chamber) {
    console.log("getDurationOptions", settlements, chamber);
    const { monthAgo, weekAgo, threeMonthsAgo } = getDates(+moment().startOf("day"));
    const defaultOptions = [
        {
            name: t("deviceRows.siloses.siloRow.lastXdays", { count: 90 }),
            value: threeMonthsAgo
        },
        {
            name: t("deviceRows.siloses.siloRow.lastXdays", { count: 30 }),
            value: monthAgo
        },
        {
            name: t("deviceRows.siloses.siloRow.lastWeek"),
            value: weekAgo
        }

    ];
    if (!chamber || !settlements) {
        return defaultOptions;
    } else {
        const settlementsForChamber = settlements.filter(o => o.PlcmntID === chamber.id);
        if (!settlementsForChamber.length) return defaultOptions;
        const options = [];
        settlementsForChamber.forEach(({ DtaStartTime, DtaEndTime }) => {
            options.push({
                name: `${moment.utc(DtaStartTime).format("DD.MM.YY")}-${DtaEndTime ? moment.utc(DtaEndTime).format("DD.MM.YY") : "..."}`,
                value: {
                    start: moment.utc(DtaStartTime).startOf("day"),
                    end: moment.utc(DtaEndTime).startOf("day"),
                }
            });
        });
        return options.sort((o2, o1) => (+o1.value.start) - (+o2.value.start));
    }
}


export const getDaysToAddBySectorType = (sectorType) => {
    switch (sectorType) {
        case SectorType.SOWS:
            return getTimeOnSowsRoom();
        case SectorType.DELIVERY:
            return getTimeOnBirthRoom();
        case SectorType.MATING:
            return getTimeOnMatingRoom();
        case SectorType.PORK_HOUSE:
            return getTimeOnPorkHouse();
        case SectorType.PIGLET_HOUSE:
            return getTimeOnPigletHouse();
        default:
            return 21;
    }
};
